import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

export interface IColorPickerScope extends ng.IScope {
    ngModel: string;
}

@NgComponent({
    token: Token.KbColorPicker,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbColorPicker extends Directive {
    constructor($timeout: ng.ITimeoutService) {
        super();
        this.restrict = "E";
        this.replace = true;
        this.scope = {
            ngModel: "="
        };
        this.require = "?ngModel";

        this.template = Dirs.component("kb-color-picker");

        this.link = (
            scope: IColorPickerScope,
            element: ng.IAugmentedJQuery,
            atts: ng.IAttributes,
            ngModel: ng.INgModelController
        ) => {

            element.minicolors({
                control: "hue",
                defaultValue: scope.ngModel || "",
                inline: false,
                letterCase: "lowercase",
                opacity: true,
                position: "bottom left",
                change: newValue => {
                    scope.$apply(() => {
                        ngModel.$setViewValue(newValue);
                    });
                }
            });
            element.parent().addClass("kb-color-picker");
            element.parent().append('<div class="kb-ripple-border"></div>');

            ngModel.$render = () => {
                $timeout(() => {
                    element.minicolors("value", ngModel.$viewValue || "");
                }, 0, false);
            };

            scope.$on("$destroy", () => {
                element.minicolors("destroy" as any);
            });
        };
    }
}
